import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { lazy, Suspense } from 'react'
import LoginPage from '@/pages/Login/LoginPage'
import FlowPage from '@/pages/Flow'
import Loading from '@/components/Loading'
import PrivateRoute from '@/components/PrivateRoute'
import PrivateLayout from '@/layouts/PrivateLayout'
import { AuthProvider } from '@/contexts/AuthContext'
import { ROUTES } from '@/constants'

const ConversationsPage = lazy(() => import('@/pages/Conversations'))
const FlowsPage = lazy(() => import('@/pages/Flows'))

const AppRoutes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path={ROUTES.LOGIN} element={<LoginPage />} />
          <Route
            element={
              <PrivateRoute>
                <PrivateLayout />
              </PrivateRoute>
            }
          >
            <Route path={ROUTES.HOME} element={<Navigate to={ROUTES.FLOWS} replace />} />
            <Route
              path={ROUTES.FLOWS}
              element={
                <Suspense fallback={<Loading open={true} />}>
                  <FlowsPage />
                </Suspense>
              }
            />
            <Route path="/flows/:flowId" element={<FlowPage />} />
            <Route
              path={ROUTES.CONVERSATIONS}
              element={
                <Suspense fallback={<Loading open={true} />}>
                  <ConversationsPage />
                </Suspense>
              }
            />
          </Route>
          <Route path="*" element={<Navigate to={ROUTES.FLOWS} replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  )
}

export default AppRoutes
